import { Component, OnInit, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA,
  MatLegacyDialogRef
} from '@angular/material/legacy-dialog';
import { InfoPopupComponent } from '../info-popup/info-popup.component';

@Component({
  selector: 'ab-radio-buttons-popup',
  templateUrl: './radio-buttons-popup.component.html',
  styleUrls: ['./radio-buttons-popup.component.scss']
})
export class RadioButtonsPopupComponent implements OnInit {
  public selection = 'CSV'; // to be refactored later

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: any,
    public dialogRef: MatLegacyDialogRef<InfoPopupComponent>
  ) {}

  ngOnInit() {}

  confirm() {
    this.dialogRef.close(this.selection);
  }
}
